/* global $ */
import { TimelineMax, TweenMax, Strong } from 'gsap';
import 'gsap/ScrollToPlugin';

import ScrollMagic from 'helpers/importers/ScrollMagic';
import legacyIsDesktop from 'helpers/legacyIsDesktop';
import resizeThrottler from 'helpers/resizeThrottler';
import scrollToSection from 'helpers/scrolling/scrollToSection';

const headerResizeHandler = function () {
  if (!legacyIsDesktop()) {
    $('#header').addClass('scrolled');
  } else {
    $('#header').removeClass('scrolled');
  }
};

export default function menuScene (controller) {
  let tween = new TimelineMax()
    .to('.homepage-splash  h1', 0.2, { autoAlpha: 0, scale: 0.8, y: -100, ease: Strong.easeOut });
  let scene = new ScrollMagic.Scene({ triggerElement: '#header', duration: '60%', triggerHook: 'onLeave' })
    .setTween(tween);
  scene.on('start', _e => {
    TweenMax.to('.scroll', 1, { autoAlpha: 0 });
  });

  scene.on('end', e => {
    if (legacyIsDesktop()) {
      if (e.scrollDirection !== 'REVERSE') {
        $('#header').addClass('scrolled');
        scrollToSection('#franchises');
      } else {
        $('#header').removeClass('scrolled');
      }
    }
  });

  scene.addTo(controller);

  if (!legacyIsDesktop()) {
    $('#header').addClass('scrolled');
  }

  $(window).on('resize', () => resizeThrottler(headerResizeHandler, 66));
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/menuScene.js